import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

import { getIsMobile } from 'src/store/view/selectors';
import {
  getVisaType,
  getVisaRulesLink,
  getVisaInfoText,
} from '../../../../routes/Checkout/store/domains/visa';
import { getHotelCountryForm2 } from '../../../../routes/Checkout/store/selectors/hotel';

import { VisaInfoWarning } from './VisaInfoWarning';

const mapStateToProps = (state) => ({
  visaType: getVisaType(state),
  warningText: getVisaInfoText(state),
  countryTo: getHotelCountryForm2(state),
  rulesLink: getVisaRulesLink(state),
  isMobile: getIsMobile(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(VisaInfoWarning);
